import Link from 'next/link'

type IProps = {
  title: string
  href: string
  description: string
  /** Rank numeral — pass only for a curated, ordered list (the featured six). */
  index?: number
}

const HelpArticleCard = ({ title, href, description, index }: IProps) => {
  return (
    <Link
      href={href}
      className="group flex flex-col gap-3 border-t border-ink-100/15 py-6 transition-colors hover:bg-cream-300/40 md:gap-4 md:py-8 md:pr-4 md:pl-2"
    >
      <div className="flex items-center justify-between gap-4">
        <span className="font-display text-[14px] font-medium tracking-[-0.01em] text-blue-500 italic md:text-[15px]">
          {index === undefined ? '' : String(index + 1).padStart(2, '0')}
        </span>
        <span
          aria-hidden="true"
          className="font-display text-[18px] text-ink-200 transition-all group-hover:translate-x-1 group-hover:text-blue-500"
        >
          →
        </span>
      </div>

      <h3 className="font-display text-[20px] leading-[1.2] font-medium tracking-[-0.005em] text-ink-700 transition-colors group-hover:text-blue-500 md:text-[24px]">
        {title}
      </h3>

      {description && (
        <p className="line-clamp-2 max-w-2xl text-[14px] leading-relaxed text-ink-200 md:text-[15px]">
          {description}
        </p>
      )}
    </Link>
  )
}

export default HelpArticleCard
